import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { FaFileDownload, FaCalendarAlt } from "react-icons/fa";
import "./Transactions.css";
import { useTranslation } from "react-i18next"; // ✅ Import i18n
import LanguageTranslation from "../components/languageTranslation"; // Optional

const getStatusClass = (status) => {
  switch (status) {
    case "Completed":
      return "status-completed";
    case "Pending":
      return "status-pending";
    case "On Hold":
      return "status-onhold";
    default:
      return "";
  }
};

const Transactions = () => {
  const { t, i18n } = useTranslation(); // ✅ Use i18next
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState("1 Jan - 1 Feb 2025");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/transactions`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTransactions(response.data);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
      setLoading(false);
    };

    fetchTransactions();
  }, []);

  return (
    <div
      className="dashboard-wrapper"
      dir={['ar', 'fa', 'ir', 'he'].includes(i18n.language) ? 'rtl' : 'ltr'}
      style={{
        flexDirection: ['ar', 'fa', 'ir', 'he'].includes(i18n.language)
          ? 'row-reverse'
          : 'row',
      }}
    >
      <div className="sidebar-fixed">
        <Sidebar isOpen={isSidebarOpen} />
      </div>

   

      <div className="dashboard-main">
        <Navbar onToggleSidebar={() => setIsSidebarOpen(prev => !prev)} />

        <div className="transaction-content">
          <div className="table-container">
            <div className="table-header">
              <h4 className="section-title">{t("TransactionHistory")}</h4>
              {/* <div className="date-range">
                <FaCalendarAlt />
                {dateRange}
              </div> */}
            </div>

            {loading ? (
              <p>{t("LoadingTransactions")}</p>
            ) : (
              <div className="table-scroll-wrapper">
                <table className="transactions-table">
                  <thead>
                    <tr>
                      <th>{t("Transactions")}</th>
                      <th>ID</th>
                      <th>{t("Date")}</th>
                      <th>{t("Amount")}</th>
                      <th>{t("Status")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((tx, index) => (
                      <tr key={index}>
                        <td>{tx.method}</td>
                        <td>{tx.transactionId}</td>
                        <td>{new Date(tx.date).toLocaleDateString()}</td>
                        <td>${tx.amount ? Number(tx.amount).toFixed(2) : "0.00"}</td>
                        <td className={getStatusClass(tx.status)}>{t(tx.status)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transactions;
